<script lang="ts">
	import { Check, Database, TriangleAlert } from 'lucide-svelte';

	import LoadingSpinner from '$lib/components/loading-spinner.svelte';
	import { Button } from '$lib/components/ui/button';
	import * as Tooltip from '$lib/components/ui/tooltip';

	import * as m from '$lib/paraglide/messages';
	import { clientRepo } from '$lib/states/client-repo.svelte';
</script>

<Button href="/settings/data" size="icon" variant="ghost" class="size-7 text-muted-foreground">
	<Tooltip.Provider delayDuration={0}>
		<Tooltip.Root open={!!clientRepo.error}>
			{#if clientRepo.status === 'ready'}
				<Tooltip.Trigger>
					<Database class="size-4" />
				</Tooltip.Trigger>

				<Tooltip.Content class="flex items-center gap-2">
					<Check class="size-4" />
					{m.database_statusReady()}
				</Tooltip.Content>
			{:else if clientRepo.error}
				<Tooltip.Trigger>
					<TriangleAlert class="size-4 stroke-destructive" />
				</Tooltip.Trigger>

				<Tooltip.Content>{m.repoInitError_tooltip()}</Tooltip.Content>
			{:else}
				<LoadingSpinner />
			{/if}
		</Tooltip.Root>
	</Tooltip.Provider>
</Button>
